import { api } from '@/lib/axios';
import type { LoginData, LoginResponse, User } from '../types';

// Auth endpoints
const ENDPOINTS = {
  LOGIN: '/api/auth/login',
  LOGOUT: '/api/auth/logout',
  REFRESH: '/api/auth/refresh',
  PROFILE: '/api/auth/profile',
} as const;

/**
 * Authentication API
 * Handles user authentication, login, logout, and profile management
 */
export const authApi = {
  /**
   * Login user with credentials
   */
  login: async (credentials: LoginData): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(ENDPOINTS.LOGIN, credentials);
    return response.data;
  },

  /**
   * Logout user
   */
  logout: async (): Promise<void> => {
    await api.post(ENDPOINTS.LOGOUT);
  },

  /**
   * Get current user profile
   */
  getProfile: async (): Promise<User> => {
    const response = await api.get<User>(ENDPOINTS.PROFILE);
    return response.data;
  },

  /**
   * Refresh authentication token
   */
  refreshToken: async (): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(ENDPOINTS.REFRESH);
    return response.data;
  },
}; 